import { cn } from '@/lib/utils'

/** Figma marketing body copy — 16px Pretendard, 150% line-height. */
export function MarketingLead({
  children,
  className,
}: {
  children: React.ReactNode
  className?: string
}) {
  return <p className={cn('marketing-lead', className)}>{children}</p>
}
